import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-effect",
  "use": "icon-effect-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-effect\">\n\t<path fill=\"none\" d=\"M0 0h24v24H0z\" />\n\t<path d=\"M12,10.57a2.86,2.86,0,1,0,2.86,2.86A2.86,2.86,0,0,0,12,10.57Zm0-1.9a4.76,4.76,0,1,1-4.76,4.76A4.76,4.76,0,0,1,12,8.67ZM18.67,5,12,8V5.73L8.76,7.6a6.67,6.67,0,0,0-3.42,5.57v.26a6.67,6.67,0,0,0,13.33.23V5Zm1.9-3V13.43a8.57,8.57,0,1,1-13-7.36l6.31-3.64V5.07Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol